import type { Auth } from '../types';
import { Api } from './api';

export class AuthApi extends Api {

  public static async isAuth(params?: { version?: number }) {
    return this.get<Auth>('/auth/is-auth', { params });
  }

  public static async logout() {
    await this.post('/auth/logout');
  }
}
